import Decorator from "../../../../src/content/blog/3-Algo/Dynamic Programming Intro/asides/Decorator.mdx";
import * as React from 'react';
export default {
  Decorator,
  React
};